<mat-form-field [ngStyle]="{ 'width': width, 'margin': '10px 20px 20px 0px'}">
  <input matInput *ngIf="formControl" [placeholder]="placeholder" [formControl]="formControl" type="text">
  <mat-error *ngIf="formControl?.invalid && formControl?.hasError('required')">Campo obrigatório</mat-error>
  <mat-error *ngIf="formControl?.invalid && formControl?.hasError('pattern')">Formato inválido</mat-error>
</mat-form-field>
